<div class="p-4 table-container mark" [ngStyle]="getContainerStyle(reportMeasurementPoint)" (click)="onClick($event)" [ngClass]="{
    'dynamic-mark': true,
    'selectable': reportMeasurementPoint.isSelectable,
    'selected': reportMeasurementPoint.isSelected,
    'edited': !reportMeasurementPoint.isSaved(),
    'highlight-hover' : designService.highlightElement }">
  <div style="height: 9mm; padding: 0 5mm; font-weight:bold" [style.fontSize]="reportMeasurementPoint.titleFontSize" [style.textAlign]="reportMeasurementPoint.titleAlign"
       [style.backgroundColor]="reportMeasurementPoint.titleBackgroundColor">{{reportMeasurementPoint.titleText}}</div>
  <div class="my-2">
    <span>**{{'reportMeasurement.sub' | translate}}**</span>
  </div>
  <div [ngStyle]="getStyles(reportMeasurementPoint)" style="position:absolute">

    <table width="100%" rules="{{reportMeasurementPoint.tableRules}}">
      <thead>
        <tr>
          <th *ngFor="let column of reportMeasurementPoint.columns" [style.padding]="reportMeasurementPoint.cellMargin+'mm'">{{column.label}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td *ngFor="let column of reportMeasurementPoint.columns" [style.padding]="reportMeasurementPoint.cellMargin+'mm'">
            <span *ngIf="column.type === 'Dynamic'">{{'[ '+ ('objects.' + column.dataField | translate) +' ]' || '--'}}</span>
            <span *ngIf="column.type === 'Editable'">[{{'objects.editableText' | translate}}]</span>
            <span *ngIf="column.type === 'Dynamic-Editable'">{{'[ '+ ('objects.' + column.dataField | translate) +' ]' || '--'}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
